// extracted by mini-css-extract-plugin
export default {"language-selector":"languageSelector_language-selector__ujBbr"};